import { useEffect, useMemo, useState, useCallback } from "react";
import { Sidebar } from "./Sidebar/Sidebar";
import styles from "./SettingsPage.module.scss";
import { ProfileSection } from "./ProfileSection/ProfileSection";
import { UsersSection } from "./UsersSection/UsersSection";
import { InnoveraHeader } from "@/frontend/components/InnoveraHeader/ui/InnoveraHeader";
import { useSearchParams } from "react-router-dom";
import { ExpertsSection } from "./ExpertsSection/ExpertsSection";
import { OrgSettingsSection } from "@/frontend/pages/SettingsPage/ui/OrgSettingsSection/OrgSettingsSection";

export function SettingsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [count, setCount] = useState<number>(0);
  const [currentSection, setCurrentSection] = useState(searchParams.get("section") || "Profile");

  // eslint-disable-next-line
  const handleApiCallFinally = () => {
    // Forces <InnoveraHeader /> to rerender when we run
    // queryClient.invalidateQueries in ProfileSection - J
    setCount((prev) => prev + 1);
  };

  useEffect(() => {
    setCurrentSection(searchParams.get("section") || "Profile");
  }, [searchParams]);

  const updateSection = useCallback(
    (section: string) => {
      setCurrentSection(section);
      setSearchParams({ section });
    },
    [setSearchParams]
  );

  const content = useMemo(() => {
    switch (currentSection) {
      case "Profile":
        return <ProfileSection handleApiCallFinally={handleApiCallFinally} />;
      case "Experts":
        return <ExpertsSection />;
      case "Settings":
        return <OrgSettingsSection />;
      default:
        return <UsersSection />;
    }
  }, [currentSection, handleApiCallFinally]);

  return (
    <div className={styles.container}>
      <InnoveraHeader type="settings" key={count} />
      <div className={styles.subContainer}>
        <Sidebar currentSection={currentSection} setCurrentSection={updateSection} />
        {content}
      </div>
    </div>
  );
}
